export default [
  {
    title: '月份',
    key: 'tdateMonth',
    width: 62
  },
  {
    title: '游戏',
    key: 'gameName',
    width: 70
  },
  {
    title: '平台',
    key: 'platform',
    width: 40
  },
  {
    title: '分配充值',
    key: 'opMoney',
    width: 140
  },
  {
    title: '30日充值金额',
    key: 'thirtyMoney',
    width: 60
  },
  {
    title: '创建人',
    key: 'createOpName'
  },
  {
    title: '更新人',
    key: 'upOpName'
  },
  {
    title: '更新时间',
    key: 'upTime',
    width: 114
  },
  {
    title: '操作',
    key: 'control',
    width: 64
  }
]
